import { reactive } from 'vue';

// Header the server puts on every /api response (Wlab::BuildIdHeader): the id of the
// dashboard front-end build it serves. The page carries the id it was rendered with in
// window.globalConfig.WLAB_BUILD_ID. When they differ, a newer build has been deployed and
// this tab is still running the old one until the agent refreshes.
export const BUILD_HEADER = 'x-wlab-build';

export const appVersionState = reactive({ updateAvailable: false });

const pageBuildId = () => window.globalConfig?.WLAB_BUILD_ID || null;

const readHeader = headers => {
  if (!headers) return null;
  if (typeof headers.get === 'function')
    return headers.get(BUILD_HEADER) || null;
  return headers[BUILD_HEADER] || null;
};

// Called with the headers of every API response (APIHelper). Once a newer build is seen
// the flag stays set: during a blue-green switch responses alternate between the two
// builds, and the banner must not flicker.
export const noteServerBuild = headers => {
  if (appVersionState.updateAvailable) return;
  const page = pageBuildId();
  const server = readHeader(headers);
  if (!page || !server) return;
  if (String(server) !== String(page)) appVersionState.updateAvailable = true;
};

export const resetAppVersion = () => {
  appVersionState.updateAvailable = false;
};
